import { parameterize } from '@sentry/remix';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Typography from '../Typography';

interface PolicyHelperProps {
  fontFamily?: string;
  utmSource?: any;
  text: string;
  url: string;
  utmMedium?: string;
  color?: string;
  className?: string;
}

const PolicyHelper = ({ fontFamily, utmSource, url, utmMedium, color, text, className }: PolicyHelperProps) => {
  const href = new URL(url);

  if (utmSource) {
    const source = parameterize(utmSource, '_');
    href.searchParams.append('utm_source', source);
  }

  if (utmMedium) {
    href.searchParams.append('utm_medium', utmMedium);
  }

  const urlToAppend = href.toString();

  return (
    <a
      href={urlToAppend}
      target="_blank"
      className={classNames('whitespace-nowrap underline underline-offset-1 hover:opacity-80', className)}
      rel="noreferrer"
      style={{
        color,
      }}
    >
      <Typography className="!text-xs" weight="light" fontFamily={fontFamily} color={color}>
        {text}
      </Typography>
    </a>
  );
};

interface Props {
  color?: string;
  fontFamily?: string;
  utmSource?: any;
  utmMedium?: string;
  className?: string;
  privacyPolicyUrl?: string;
  termsOfUseUrl?: string;
}

const TermsOfUse = ({ fontFamily, utmSource, utmMedium, color, className, termsOfUseUrl }: Props) => {
  const { t } = useTranslation();

  return (
    <PolicyHelper
      fontFamily={fontFamily}
      utmSource={utmSource}
      url={termsOfUseUrl || 'https://beehiiv.com/tou'}
      utmMedium={utmMedium}
      text={t('footer.terms_of_use')}
      color={color}
      className={className}
    />
  );
};

const PrivacyPolicy = ({ color, fontFamily, utmSource, className, privacyPolicyUrl }: Props) => {
  const { t } = useTranslation();

  return (
    <PolicyHelper
      fontFamily={fontFamily}
      utmSource={utmSource}
      url={privacyPolicyUrl || 'https://beehiiv.com/privacy'}
      text={t('footer.privacy_policy')}
      color={color}
      className={className}
    />
  );
};

export { PrivacyPolicy, TermsOfUse };
